<template>
  <div class="page">
    <div class="ctrl">共 {{ list.length }} 条</div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimgurl" slot-scope="text, record">
        <img style="height: 32px" :src="record.headimgurl" alt="" />
      </template>
      <template slot="amount" slot-scope="text, record">
        <router-link :to="'/auction/order/goodsList?order_id=' + record.id">
          <a-button size="small">{{ record.amount }}</a-button>
        </router-link>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == -1" color="red">已取消</a-tag>
        <a-tag v-if="record.status == 0" color="orange">未支付</a-tag>
        <a-tag v-if="record.status == 1" color="green">已支付</a-tag>
        <a-tag v-if="record.status == 2" color="orange">已发货</a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-button size="small" @click="fahuoModal.show = true; fahuoModal.order_id = record.id">发货</a-button>
      </template>
    </a-table>

    <a-modal v-model="fahuoModal.show" title="发货" @ok="sub">
      <a-form label-col="span: 4" wrapper-col="span: 19">
        <a-textarea
          placeholder="请填写发货备注"
          v-model="fahuoModal.remarks"
          :auto-size="{ minRows: 4, maxRows: 6 }"
        />
      </a-form>
    </a-modal>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "手机",
    dataIndex: "tel",
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "数量",
    scopedSlots: {
      customRender: "amount",
    },
  },
  {
    title: "总价",
    dataIndex: "money",
  },
  {
    title: "下单时间",
    dataIndex: "created_at",
  },
  {
    title: "支付时间",
    dataIndex: "payed_at",
  },
  {
    title: "支付单号",
    dataIndex: "out_trade_no",
  },
  {
    title: "发货时间",
    dataIndex: "fahuo_at",
  },
  {
    title: "发货备注",
    dataIndex: "remarks",
  },

  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export default {
  data() {
    return {
      auction_id: null,
      columns,
      list: [],
      fahuoModal: {
        show: false,
        order_id: null,
        remarks: "",
      },
    };
  },
  created() {
    this.auction_id = this.$route.query.auc_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get(
        "/auction/order/getList?auction_id=" + this.auction_id
      );
      console.log(r);

      if (r.status == 1) this.list = r.list;
    },

    async sub () {
      const r = await this.$axios.post('/auction/order/fahuo', this.fahuoModal);
      if(r.status == 1){
        this.fahuoModal = {
          show: false,
          remarks: ''
        }
        this.getList()
      }
    }
  },
};
</script>